<template>
  <v-card>
    <v-card-title>
      <v-spacer />
      <v-btn @click="cancel" icon>
        <v-icon>
          close
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text >
      <v-alert type="warning" v-if="!$store.getters.isCurrentSubscriptionPlanAvailable">
        IMPORTANT!!! - Your current plan is grandfathered in.  If you cancel, you won't be able to resubscribe at the same price.
      </v-alert>
      <flow-form style="padding-top: 10px; padding-bottom: 10px;" :standalone="false" :progressbar="false" :navigation="false" :questions="questions" :language="languageModel" @complete="onComplete" @submit="onComplete">
        <div slot="complete" class="text-h4">
          We're cancelling your subscription.<br /><br />
          Please don't navigate away or click the back button.  You'll be redirected shortly.
        </div>
        <div slot="completeButton"></div>
      </flow-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="cancel" color="primary" :disabled="cancelling">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FlowForm, { QuestionModel, QuestionType, ChoiceOption, LanguageModel } from '@ditdot-dev/vue-flow-form'
// import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css'
// import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-minimal.css'

export default {
  name: "CancelationSurvey",
  components: {
    FlowForm
  },
  data() {
    return {
      cancelling: false,
      languageModel: new LanguageModel({
        thankYouText: 'Thanks for the feedback!',
        successText: 'Your subscription has been canceled.',
        submitText: 'Cancel Subscription'
      }),
      questions: [
        new QuestionModel({
          id: 'start',
          type: QuestionType.MultipleChoice,
          title: 'Would you mind letting us know why you\'re canceling?',
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: 'Truple was extremely helpful and accountability is no longer needed',
              value: 'extremely-helpful'
            }),
            new ChoiceOption({
              label: 'Truple was somewhat helpful and accountability is no longer needed',
              value: 'somewhat-helpful'
            }),
            new ChoiceOption({
              label: 'Truple didn\'t help',
              value: 'not-helpful'
            }),
            new ChoiceOption({
              label: 'Missing features',
              value: 'features'
            }),
            new ChoiceOption({
              label: 'Too many loopholes',
              value: 'loopholes'
            }),
            new ChoiceOption({
              label: 'Unstable app or monitoring',
              value: 'unstable'
            }),
            new ChoiceOption({
              label: 'Difficult to setup',
              value: 'setup'
            }),
            new ChoiceOption({
              label: 'Need coverage for more platforms',
              value: 'platforms'
            }),
            new ChoiceOption({
              label: 'Other',
              value: 'other'
            })
          ],
          jump: {
            'extremely-helpful': '_submit',
            'somewhat-helpful': 'somewhat-helpful',
            'not-helpful': 'not-helpful',
            features: 'features',
            loopholes: 'loopholes',
            unstable: 'unstable',
            setup: 'setup',
            platforms: 'platforms',
            other: 'other',
          }
        }),
        new QuestionModel({
          id: 'somewhat-helpful',
          title: 'Do you have any feedback for how we could improve Truple?',
          type: QuestionType.LongText,
          jump: () => { return '_submit'}
        }),
        new QuestionModel({
          id: 'not-helpful',
          title: 'Why didn\'t Truple help?',
          type: QuestionType.LongText,
          jump: () => { return '_submit'}
        }),
        new QuestionModel({
          id: 'features',
          title: 'What features would you like to see added?',
          type: QuestionType.LongText,
          jump: () => { return '_submit'}
        }),
        new QuestionModel({
          id: 'loopholes',
          title: 'Could you please explain the loophole?',
          subtitle: 'We\'ll do our best to patch up the loophole.',
          type: QuestionType.LongText,
          jump: () => { return '_submit'}
        }),
        new QuestionModel({
          id: 'unstable',
          title: 'What platform did you have stability issues with?',
          type: QuestionType.MultipleChoice,
          multiple: true,
          options: [
            new ChoiceOption({
              label: 'Android',
              value: 'android'
            }),
            new ChoiceOption({
              label: 'Windows',
              value: 'windows'
            }),
            new ChoiceOption({
              label: 'MacOS',
              value: 'macos'
            }),
            new ChoiceOption({
              label: 'Chromebook',
              value: 'chromebook'
            }),
            new ChoiceOption({
              label: 'Kindle',
              value: 'kindle'
            }),
            new ChoiceOption({
              label: 'Linux',
              value: 'linux'
            }),
            new ChoiceOption({
              label: 'iOS (iPhone/iPad)',
              value: 'ios'
            })
          ],
          jump: () => {
            return '_submit'
          }
        }),
        new QuestionModel({
          id: 'setup',
          title: 'What did you find difficult about the setup?',
          description: 'For example, "adding my husbands device to the account while he was traveling and I couldn\'t access his device myself"',
          type: QuestionType.LongText,
          jump: () => { return '_submit'}
        }),
        new QuestionModel({
          id: 'platforms',
          title: 'What platforms are you looking for?',
          subtitle: 'Truple is already available for Android, iOS (iPhone / iPad), Kindle, Chromebook, Windows, MacOS, and Linux.',
          type: QuestionType.Text,
          jump: () => { return '_submit' }
        }),
        new QuestionModel({
          id: 'other',
          title: 'Care to explain?',
          type: QuestionType.Text,
          jump: () => { return '_submit' }
        })
      ]
    }
  },
  methods: {
    prepareAnswers(questionList) {
      console.log(questionList)
      let answers = questionList.map(x => {
        return {
          id: x.id,
          answer: x.answer
        }
      })
      console.log(answers)
      return answers
    },
    onComplete(completed, questionList) {
      this.cancelling = true
      console.log('onComplete')
      if(completed && questionList) {
        this.$emit('on-complete', this.prepareAnswers(questionList))
      }
      this.cancelling = false
    },
    onSubmit() { //we submit on complete
      console.log('onSubmit')
      // this.$emit('on-complete', this.prepareAnswers(questionList))
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="css">
  /*@import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css';*/
  /*@import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-minimal.css';*/


  /*!
    taken from https://unpkg.com/@ditdot-dev/vue-flow-form@2.1.0/dist/vue-flow-form.theme-minimal.min.css
    due to issues: https://github.com/ditdot-dev/vue-flow-form/issues/207
*/


  .vff {
    font-weight: 400;
    line-height: 1.34;
    min-height: 220px;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-font-smoothing: antialiased;
    -o-font-smoothing: antialiased;
  }

  @media screen and (max-width:1023px){
    .vff,
    .vff-footer {
      font-size: 15px;
    }

  }

  @media screen and (min-width:1366px) {
    .vff,
    .vff-footer {
      font-size: 18px;
    }

  }

  @media screen and (min-width:1920px) {
    .vff {
      font-size: 22px;
    }

  }

  @media screen and (min-width:2560px) {
    .vff {
      font-size: 25px;
    }

  }

  /*
    global
  */

  .vff hr{
    box-sizing: content-box;
    overflow: visible;
    height: 0;
  }

  .vff pre,
  .vff code,
  .vff kbd {
    font-family: monospace, monospace;
    font-size: 1em;
  }

  .vff small {
    font-size: 80%;
  }

  .vff sub,
  .vff sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  .vff sub {
    bottom: -0.25em;
  }

  .vff sup {
    top: -0.5em;
  }

  .vff b,
  .vff strong {
    font-weight: bolder;
  }

  .vff a {
    cursor: pointer;
    background-color: transparent;
  }

  .vff a,
  .vff a:hover,
  .vff a:active,
  .vff a:focus {
    outline: 0;
    text-decoration: none;
  }

  .vff ol,
  .vff ul,
  .vff table {
    margin-top: 0;
    margin-bottom: 22px;
  }

  .vff img {
    max-width: 100%;
    height: auto;
    margin-bottom: 22px;
  }

  /*utils*/
  .vff .text-thin {
    font-weight: 300;
  }

  .vff .disabled,
  .vff [disabled] {
    opacity: .4;
    user-select: none;
    pointer-events: none;
    cursor: not-allowed;
  }

  .vff .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

  .vff ol.reset-list,
  .vff ul.reset-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  /*
    vff-form
  */

  .vff {
    width: 100%;
    padding: 0 10%;
    margin: 18vh 0 60px;
    position: relative;
    text-align: left;
    box-sizing: border-box;
  }

  header.vff-header + .vff{
    margin-top: 16vh;
  }

  header.vff-header + .vff.vff-not-standalone{
    margin-top: 0;
  }

  .vff *,
  .vff *:before,
  .vff *:after {
    box-sizing: inherit;
  }

  .vff .q-is-active {
    opacity: 1;
  }

  .vff .q-form.q-is-inactive {
    display: none;
  }

  .vff .f-full-width {
    display: block;
    width: 100%;
  }

  .vff .f-string-em {
    text-transform: uppercase;
  }

  .vff .f-enter {
    margin-bottom: 20px;
  }

  /*container*/
  .vff .f-container,
  header.vff-header .f-container{
    padding: 0 8%;
    width: 100%;
  }

  .vff .f-container {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  /*header*/
  header.vff-header {
    line-height: 1;
    padding: .9em 10% .8em;
    box-sizing: border-box;
    position: static;
    width: 100%;
  }

  .vff-header *,
  .vff-header *:before,
  .vff-header *:after {
    box-sizing: inherit;
  }

  header.vff-header .f-container {
    margin: 0;
  }

  header.vff-header img.f-logo,
  header.vff-header svg.f-logo {
    height: 18px;
    max-width: 240px;
    opacity: 1;
  }

  /*
    form elements
  */

  .vff button,
  .vff input,
  .vff optgroup,
  .vff select,
  .vff textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }

  .vff fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  .vff legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }

  .vff [type="number"]::-webkit-inner-spin-button,
  .vff [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  .vff [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }

  .vff [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  .vff [type="file"] {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    border: 0;
    outline: 0;
    border-radius: 0;
    margin: 0 .2em;
    padding: .1em 0 .15em;
    font-size: .72em;
    line-height: normal;
    font-weight: 900;
  }

  .vff input[type=file]:focus{
    outline: 1px dotted #000;
    outline-offset: 4px;
  }

  @media (prefers-color-scheme: dark) {
    .vff input[type=file]:focus{
      outline-color: #fff;
    }

  }

  .vff input[type=file]::-webkit-file-upload-button {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    outline: 0;
    border: 0;
    font: inherit;
    font-size: .86em;
    font-weight: 400;
    margin-right: .7em;
    text-align: center;
    max-width: 100%;
    min-width: 90px;
    min-height: 44px;
    display: inline-block;
    white-space: pre-wrap;
    cursor: pointer;
    padding: .6em 1.4em;
    background-color: #efefef;
  }

  .vff input[type=file]::-webkit-file-upload-button:active{
    color: #000;
  }

  .vff input[type=file]::file-selector-button{
    min-height: 44px;
    display: inline-block;
    white-space: pre-wrap;
    font: inherit;
    font-size: .86em;
    font-weight: 400;
    margin-right: .6em;
    max-width: 100%;
    min-width: 90px;
  }

  /*buttons*/
  .vff button,
  .vff [type="button"],
  .vff [type="reset"],
  .vff [type="submit"],
  .vff input {
    -webkit-appearance: none;
    overflow: visible;
  }

  /*default button*/
  .vff button {
    border: none;
    outline: 0;
    cursor: pointer;
    padding: .6em 1.4em;
    text-align: center;
    display: inline-block;
    min-height: 44px;
    white-space: pre-wrap;
    max-width: 100%;
  }

  .vff .o-btn-action {
    z-index: 1;
    line-height: 1.2;
    font-weight: 900;
    text-transform: lowercase;
  }

  .vff .o-btn-action span {
    font-size: 1em;
    user-select: none;
    text-decoration: none;
    transition: all 0.4s ease 0s;
  }

  .vff .f-enter-desc {
    font-size: .9em;
    display: inline-block;
    margin-left: .6em;
    margin-top: .7em;
  }

  .vff span.faux-form {
    border-bottom: 1px solid;
    display: inline-block;
    margin-right: .2em;
    margin-left: 0;
    position: relative;
    white-space: nowrap;
  }

  .vff select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    text-transform: none;
    background: transparent;
    border-radius: 0;
    border: 0;
    cursor: pointer;
    font-size: .5em;
    line-height: 1.32;
    margin: 0;
    opacity: 0;
    outline: 0;
    padding: .6em 8px;
    width: 100%;
    position: absolute;
    z-index: 1;
  }

  .vff input[type=text],
  .vff input[type=number],
  .vff input[type=tel],
  .vff input[type=email],
  .vff input[type=url],
  .vff input[type=password],
  .vff input[type=date],
  .vff textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid;
    border-radius: 0;
    line-height: 1.48;
    margin: 0 .6em 0 0;
    outline: 0;
    padding: .16em .2em;
    font-size: .72em;
    font-weight: 900;
  }

  .vff .f-other.f-selected .f-label {
    font-weight: 900;
  }

  .vff textarea {
    overflow: auto;
    display: block;
    outline: none;
    resize: vertical;
  }

  .vff .f-full-width input[type=text],
  .vff .f-full-width input[type=number],
  .vff .f-full-width input[type=tel],
  .vff .f-full-width input[type=email],
  .vff .f-full-width input[type=url],
  .vff .f-full-width input[type=password],
  .vff .f-full-width input[type=date],
  .vff .f-full-width input[type=file],
  .vff .f-full-width textarea,
  .vff .f-full-width span.faux-form{
    width: 100%;
    padding-left: .16em;
    padding-right: .16em;
  }

  .vff .f-required {
    display: none; /*hides required asterisks*/
  }

  .vff .f-answer.f-full-width {
    margin-top: 26px;
  }

  .vff span.f-sub + .f-answer.f-full-width{
    margin-top: 22px;
  }

  .vff div.field-sectionbreak .f-answer {
    margin-top: 18px;
  }

  .vff span.f-empty {
    display: inline-block;
    min-width: 3em;
    padding-right: 28px;
    font-weight: 300;
    padding-bottom: 4px;
  }

  .vff span.f-answered{
    font-weight: 900;
  }

  /*faux select arrow*/
  .vff .f-arrow-down {
    display: inline-block;
    margin-left: .2em;
    pointer-events: none;
    width: 18px;
    height: 100%;
    position: absolute;
    right: 0;
    bottom: 0;
    line-height: 1.3;
  }

  .vff .f-arrow-down svg {
    width: 100%;
    height: auto;
  }

  /* ios datepicker */
  .vff.vff-is-ios .field-date:not(.f-has-value) .f-answer > span {
    position: relative;
    top: 0;
    left: 0;
  }

  .vff.vff-is-ios .field-date:not(.f-has-value) .f-answer > span::before {
    position: absolute;
    content: attr(data-placeholder);
    display: block;
    pointer-events: none;
    padding: 0.12em .2em;
  }

  .vff.vff-is-ios input[type=date] {
    height: 32px;
    display: block;
  }

  /*
    links
  */

  .vff a.f-link,
  .vff .field-submit .f-section-wrap a {
    color: inherit;
    border-bottom: 1px dotted;
    word-break: break-word;
  }

  .vff a.f-link:hover,
  .vff a.f-link:active,
  .vff .field-submit .f-section-wrap a:hover,
  .vff .field-submit .f-section-wrap a:active {
    color: inherit;
    border-bottom: none;
  }

  /*
    typography
  */

  .vff li,
  .vff p,
  .vff .f-section-text,
  .vff span.f-tagline,
  .vff span.f-sub {
    font-size: 1.1em;
    line-height: 1.34;
  }

  .vff h1,
  .vff .fh1 {
    font-weight: 900;
    font-size: 3em;
    margin: 0.67em 0;
  }

  .vff h2,
  .vff .fh2 {
    font-weight: 900;
    font-size: 2.4em;
    line-height: 1.34;
    padding-right: 1.8em;
    margin-bottom: 20px;
  }

  .vff h3,
  .vff .fh3 {
    font-weight: 300;
    font-size: 1.5em;
    margin-top: 0;
    margin-bottom: 0;
  }

  .vff .fh1,
  .vff .fh2,
  .vff .fh3{
    display: block;
  }

  /*misc-typography*/
  .vff span.f-tagline,
  .vff span.f-sub {
    font-weight: 400;
    display: block;
  }

  .vff .fh2 span.f-tagline,
  .vff .fh2 span.f-sub{
    font-size: .51em;
  }

  .vff span.f-tagline,
  .vff span.f-text {
    margin-bottom: 8px;
  }

  .vff span.f-sub {
    margin-bottom: 8px;
    margin-top: 5px;
  }

  .vff span.f-sub span:not(.f-string-em) {
    margin-right: .4em;
  }

  .vff span.f-sub span.f-help{
    display: block;
  }

  .vff span.f-sub span + span.f-help {
    margin-top: 0;
  }

  .vff span.f-text {
    margin-right: .6em;
  }

  /*description*/
  .vff p.f-description {
    margin-top: 0;
    padding-right: 4em;
  }

  .vff p.f-description span,
  .vff p.f-description a.f-link {
    margin-right: 8px;
  }

  /*
    f-radios (multiple choice)
  */

  .vff ul.f-radios {
    margin: 0;
    padding: 0;
    list-style-type: none;
    max-width: 590px;
    min-width: 160px;
  }

  .vff ul.f-radios li {
    padding: .6em .68em;
    margin: .5em 0 .6em;
    font-weight: 300;
    line-height: 1.24;
    cursor: default;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    overflow: hidden;
  }

  .vff ul.f-radios li.f-other input[type=text] {
    border-bottom: none;
    width: 100%;
    padding: 0;
    margin: 0;
    border: 0;
    line-height: inherit;
    font-size: inherit;
  }

  .vff .f-radios-desc {
    display: block;
  }

  .vff .f-radios-desc,
  .vff ul.f-radios li,
  .vff ul.f-radios li input[type=text] {
    font-size: .4em;
  }

  .vff ul.f-radios li div.f-label-wrap{
    display: -ms-flexbox;
    display: flex;
    width: 100%;
  }

  .vff ul.f-radios li span.f-label {
    margin-left: .4em;
  }

  .vff ul.f-radios li span.f-key {
    width: 16px;
    text-align: center;
  }

  /*
    f-radios (multiple picture choice)
  */

  .vff .field-multiplepicturechoice ul.f-radios{
    max-width: 750px;
    min-width: auto;
    display: -ms-flexbox;
    display: flex;
    margin: 0 -8px 0 0;
    flex-flow: 0 1;
    -moz-box-align: stretch;
    align-items: stretch;
    flex-wrap: wrap;
  }

  .vff .field-multiplepicturechoice ul.f-radios li{
    position: relative;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    -moz-box-align: center;
    align-items: center;
    flex-direction: column;
    padding: 8px 8px 10px;
    margin-bottom: 8px;
    margin-right: 8px;
    -ms-flex: 0 0 calc(25% - 8px);
    flex: 0 0 calc(25% - 8px);
    font-size: 15px;
    line-height: 1.38;
  }

  .vff .field-multiplepicturechoice ul.f-radios li span.f-image{
    display: flex;
    display: -ms-flexbox;
    -moz-box-align: center;
    align-items: center;
    -moz-box-pack: center;
    justify-content: center;
    overflow: hidden;
    width: 100%;
    height: 140px;
    margin-bottom: 8px;
  }

  .vff .field-multiplepicturechoice ul.f-radios li span.f-image img{
    margin-bottom: 0;
    max-height: 100%;
    max-width: 100%;
  }

  /*
    footer
  */

  .vff-footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    font-weight: 300;
    line-height: 1.2;
  }

  .vff-footer .footer-inner-wrap {
    text-align: right;
    padding: 11px 20px 12px;
  }

  .vff-footer .f-progress,
  .vff-footer .f-nav,
  .vff-footer .f-timer {
    display: inline-block;
  }

  .vff-footer .f-timer {
    font-family: monospace;
    font-size: 17px;
    margin-left: .18em;
  }

  .vff-footer .f-prev,
  .vff-footer .f-next,
  .vff-footer .f-progress {
    margin: 0 .18em;
    padding: .2em .2em;
  }

  .vff-footer .f-progress {
    top: -1px;
    position: relative;
  }

  .vff-footer a.f-disabled {
    opacity: .4;
    cursor: default;
    pointer-events: none;
  }

  .vff-footer .f-prev svg,
  .vff-footer .f-next svg {
    display: inline-block;
    transition: fill 0.2s ease 0s;
    width: 23px;
    height: 13px;
  }

  .vff-footer .f-nav-text {
    display: none;
  }

  /*progress-bar*/
  .vff-footer .f-progress-bar {
    height: 1px;
    position: static;
    display: inline-block;
    width: 64px;
    vertical-align: middle;
    margin: 0 6px 0 0;
  }

  .vff-footer .f-progress-bar-inner {
    height: 1px;
    transition: width .3s ease;
  }

  /*section breaks*/
  .vff .f-section-wrap {
    margin-bottom: 30px;
  }

  .vff .f-section-wrap > div,
  .vff .f-submit {
    margin-bottom: 20px;
  }

  .vff .field-sectionbreak,
  .vff .field-submit {
    max-width: 920px;
  }

  /*
    not-standalone option
  */

  .vff.vff-not-standalone{
    height: 100%;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 50px;
    padding-bottom: 100px;
  }

  .vff.vff-not-standalone .f-container{
    margin: 0;
  }

  .vff.vff-not-standalone .vff-footer{
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  /*
    animations
  */

  .vff-animate {
    -webkit-animation-duration: .4s;
    animation-duration: .4s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  /* prevent Android Chrome flickering */
  .vff-animate * {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .vff .f-fade-in {
    animation-name: ffadeIn;
  }

  @keyframes ffadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }

  }

  .vff .f-fade-in-down {
    animation-name: ffadeInDown;
  }

  @keyframes ffadeInDown {
    0% {
      opacity: 0;
      transform: translate3d(0, -12px, 0);
    }

    100% {
      opacity: 1;
      transform: none;
    }

  }

  .vff .f-fade-in-up {
    animation-name: ffadeInUp;
  }

  @keyframes ffadeInUp {
    0% {
      opacity: 0;
      transform: translate3d(0, 12px, 0);
    }

    100% {
      opacity: 1;
      transform: none;
    }

  }

  /*
    media-start
  */

  @media only screen and (min-width: 1440px) {
    .vff .field-sectionbreak,
    .vff .field-submit {
      max-width: 960px;
    }

    .vff h2,
    .vff .fh2 {
      padding-right: 2.2em;
    }

  }

  @media only screen and (min-width: 1920px) {
    .vff .field-sectionbreak,
    .vff .field-submit {
      max-width: 1160px;
    }

  }

  @media screen and (max-width: 1366px) {
    header.vff-header,
    .vff {
      padding-right: 5%;
      padding-left: 5%;
    }

  }

  @media only screen and (max-width: 1023px) {
    header.vff-header {
      padding-left: 0;
      padding-right: 0;
    }

    .vff {
      padding-left: 0;
      padding-right: 0;
    }

  }

  @media only screen and (max-width: 767px) {
    .vff h2,
    .vff .fh2 {
      font-size: 2.2em;
      padding-right: 0;
    }

    .vff input[type=text],
    .vff input[type=number],
    .vff input[type=tel],
    .vff input[type=email],
    .vff input[type=url],
    .vff input[type=password],
    .vff input[type=date],
    .vff input[type=file],
    .vff textarea{
      font-size: .78em;
    }

    .vff input[type=file] {
      font-size: .64em;
    }

    .vff .fh2 span.f-sub,
    .vff .fh2 span.f-tagline{
      font-size: .58em;
    }

    .vff .f-container,
    header.vff-header .f-container{
      padding: 0 5.5%;
    }

    .vff span.f-empty {
      min-width: 2.2em;
      padding-right: 20px;
    }

    .vff p.f-description{
      padding-right: 0;
    }

    .vff .field-multiplepicturechoice ul.f-radios li{
      font-size: 14px;
    }

    .vff .field-multiplepicturechoice ul.f-radios li span.f-image{
      height: 90px;
    }

  }

  @media screen and (max-width:479px) {
    .vff {
      margin-top: 10vh;
      min-height: 180px;
    }

    header.vff-header + .vff{
      margin-top: 8vh;
    }

    header.vff-header + .vff.vff-not-standalone{
      margin-top: 0;
    }

    .vff input[type=text],
    .vff input[type=number],
    .vff input[type=tel],
    .vff input[type=email],
    .vff input[type=url],
    .vff input[type=password],
    .vff input[type=date],
    .vff input[type=file],
    .vff textarea {
      line-height: 1.4;
      padding: .16em .2em;
    }

    .vff input[type=file] {
      font-size: .6em;
    }

    .vff select {
      font-size: .72em;
      padding-top: .2em;
      padding-bottom: .2em;
    }

    .vff button {
      min-height: 42px;
    }

    .vff .f-arrow-down {
      width: 12px;
    }

    .vff .fh2 span.f-sub,
    .vff .fh2 span.f-tagline {
      font-size: .64em;
    }

    .vff span.f-tagline {
      line-height: 1.5;
    }

    .vff span.f-text{
      margin-right: 0;
    }

    .vff h2,
    .vff .fh2 {
      font-size: 1.56em;
    }

    .vff ul.f-radios li,
    .vff ul.f-radios li input[type=text] {
      font-size: .62em;
    }

    .vff .field-sectionbreak p {
      font-size: 1em;
    }

    .vff-footer .f-timer {
      font-size: 16px;
    }

    .vff .field-multiplepicturechoice ul.f-radios {
      max-width: 320px;
    }

    .vff .field-multiplepicturechoice ul.f-radios li{
      -ms-flex: 0 0 calc(50% - 8px);
      flex: 0 0 calc(50% - 8px);
    }

  }

  @media screen and (max-height:400px) {
    .vff {
      margin-top: 12vh;
      min-height: 180px;
    }

    header.vff-header {
      position: static;
    }

    .vff-footer{
      font-size: 15px;
    }

    .vff-footer .footer-inner-wrap {
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .vff .f-radios-desc,
    .vff ul.f-radios li,
    .vff ul.f-radios li input[type=text] {
      font-size: 14px;
    }

    .vff h2,
    .vff .fh2 {
      font-size: 1.56em;
    }

    .vff .fh2 span.f-sub,
    .vff .fh2 span.f-tagline {
      font-size: .6em;
    }

    .vff .field-multiplepicturechoice ul.f-radios li span.f-image{
      height: 90px;
    }

  }

  /*!
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://github.com/ditdot-dev/vue-flow-form
    https://www.ditdot.hr/en
*/

  /*
    basic theme color and font styles
  */

  :root {
    --vff-bg-color: #fff;
    --vff-main-text-color: #181818;
    --vff-secondary-text-color: #999;
    --vff-tertiary-text-color: #f1f1f1;
    --vff-main-accent-color: #00796B;
    --vff-secondary-accent-color: #BBEBD5;
  }

  .vff,
  .vff textarea,
  .vff input,
  .vff select,
  .vff select option,
  .vff kbd,
  .vff-header,
  .vff-footer{
    font-family: 'Poppins', sans-serif;
  }

  body {
    /*override if needed when using not-standalone option*/
    margin: 0;
    background-color: var(--vff-bg-color);
  }

  .vff{
    color: var(--vff-main-text-color);
  }

  .vff.vff-not-standalone{
    background-color: var(--vff-bg-color);
    color: var(--vff-main-text-color);
  }

  header.vff-header{
    background-color: var(--vff-secondary-accent-color);
  }

  header.vff-header svg.f-logo{
    fill: rgba(0,0,0,0.9);
  }

  .vff input[type=text],
  .vff input[type=number],
  .vff input[type=tel],
  .vff input[type=email],
  .vff input[type=url],
  .vff input[type=password],
  .vff input[type=date],
  .vff textarea,
  .vff span.faux-form {
    border-bottom-color: var(--vff-secondary-text-color);
  }

  .vff textarea,
  .vff input,
  .vff select option {
    color: var(--vff-main-text-color);
  }

  .vff a,
  .vff a:active {
    color: var(--vff-main-text-color);
  }

  /*placeholder*/
  .vff ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: var(--vff-secondary-text-color);
    opacity: 1;
    font-weight: 300;
  }

  .vff ::-moz-placeholder { /* Firefox 19+ */
    color: var(--vff-secondary-text-color);
    opacity: 1;
    font-weight: 300;
  }

  .vff :-ms-input-placeholder { /* IE 10+ */
    color: var(--vff-secondary-text-color)!important;
    opacity: 1!important;
    font-weight: 300!important;
  }

  .vff :-moz-placeholder { /* Firefox 18- */
    color: #999;
    opacity: 1;
    font-weight: 300;
  }

  /*faux input type date placeholder for iOS*/
  .vff.vff-is-ios .field-date:not(.f-has-value) .f-answer > span::before{
    color: var(--vff-secondary-text-color);
    font-weight: 300;
    font-size: .72em;
  }

  /*field-multiplechoice*/
  .vff ul.f-radios li {
    border: 1px solid var(--vff-secondary-text-color);
  }

  .vff ul.f-radios li.f-selected,
  .vff ul.f-radios li:active {
    border-color: var(--vff-main-text-color);
    background-color: var(--vff-tertiary-text-color);
  }

  .vff ul.f-radios li.f-other.f-selected input {
    color: inherit;
  }

  .vff .f-key{
    color: var(--vff-secondary-text-color);
  }

  /*field-dropdown*/
  .vff span.f-empty {
    color: var(--vff-secondary-text-color);
  }

  .vff span.f-answered{
    color: var(--vff-main-text-color);
  }

  .vff .f-arrow-down svg {
    fill: var(--vff-main-text-color);
  }

  /*buttons*/
  .vff .o-btn-action {
    color: var(--vff-bg-color);
    background-color: var(--vff-main-text-color);
  }

  .vff .o-btn-action:hover,
  .vff .o-btn-action:focus {
    background-color: var(--vff-main-text-color);
    opacity: .9;
  }

  /*footer*/
  .vff-footer .footer-inner-wrap{
    background-color: rgba(255,255,255,0.75);
  }

  @media screen and (max-width:479px) {
    .vff-footer .footer-inner-wrap{
      background-color: rgba(240,240,240,0.75);
    }

  }

  .vff-footer .f-prev svg,
  .vff-footer .f-next svg {
    fill: var(--vff-main-text-color);
  }

  .vff-footer .f-progress {
    color: var(--vff-secondary-text-color);
  }

  .vff-footer .f-progress-bar {
    background-color: var(--vff-secondary-text-color);
    filter: brightness(1.2);
  }

  .vff-footer .f-progress-bar-inner {
    background-color: var(--vff-main-text-color);
  }

  .vff-footer .f-prev:hover,
  .vff-footer .f-next:hover,
  .vff-footer .f-prev:focus,
  .vff-footer .f-next:focus{
    background-color: rgba(0,0,0,0.07);
  }

  /*alerts*/
  .vff .text-alert,
  .vff .f-invalid{
    color: #F5554A;
  }

  .vff .text-success{
    color: #4CAF50;
  }

  /*text-muted*/
  .vff span.f-tagline,
  .vff span.f-sub,
  .vff p.f-description,
  .vff .text-muted {
    color: var(--vff-secondary-text-color);
  }

  /*
    dark mode styles
  */

  @media (prefers-color-scheme: dark) {
    :root {
      --vff-bg-color: #313640;
      --vff-main-text-color: #fff;
      --vff-secondary-text-color: #AEB6BF;
      --vff-tertiary-text-color: #41464F;
      --vff-main-accent-color: #41B883;
      --vff-secondary-accent-color: #A0DBC1;
    }

    header.vff-header{
      background-color: #313640;
    }

    header.vff-header svg.f-logo{
      fill: var(--vff-main-accent-color);
    }

    .vff textarea,
    .vff input,
    .vff select option {
      color: var(--vff-main-accent-color);
    }

    .vff input[type=date]::-webkit-calendar-picker-indicator {
      filter: invert(100%);
    }

    .vff span.f-answered{
      color: var(--vff-main-accent-color);
    }

    .vff .f-arrow-down svg {
      fill: var(--vff-main-accent-color);
    }

    .vff .text-success{
      color: var(--vff-main-accent-color);
    }

    /*footer*/
    .vff-footer .footer-inner-wrap{
      background-color: rgba(49,54,64,0.75);
    }

    .vff-footer .f-prev svg,
    .vff-footer .f-next svg {
      fill: var(--vff-main-accent-color);
    }

    .vff-footer .f-prev.f-disabled svg,
    .vff-footer .f-next.f-disabled svg {
      fill: var(--vff-main-text-color);
    }

    .vff-footer .f-prev:hover,
    .vff-footer .f-next:hover{
      background-color: rgba(0,0,0,0.2);
    }

    .vff-footer .f-progress-bar {
      background-color: var(--vff-secondary-text-color);
      filter: brightness(1);
    }

    .vff-footer .f-progress-bar-inner {
      background-color: var(--vff-main-accent-color);
    }

    /*field-multiplechoice*/
    .vff ul.f-radios li.f-selected{
      color: var(--vff-main-accent-color);
    }

    .vff ul.f-radios li{
      font-weight: 900;
      color: var(--vff-secondary-text-color);
    }

    .vff .f-key{
      font-weight: 400;
      color: var(--vff-main-accent-color);
    }

  }


  .footer-inner-wrap {
    display: none;
  }
</style>